import * as R from 'ramda'

import {
  RabbitMessageType,
  type RabbitIncidentMessage,
} from '@collector/queue-gateway-shared-types'
import { Incident } from '@collector/sportsapi-client'

import {
  IncidentIdIncidentIndexMap,
  IncidentUpdate,
} from './queueRabbitClient/types'

/**
 * Creates an incident update object from an API incident for the `incidentsUpdate` array
 */
export function getApiIncidentUpdate(apiIncident: Incident): IncidentUpdate {
  return {
    data: apiIncident,
    uuid: apiIncident.generated_id,
    type: RabbitMessageType.Incident,
    source: apiIncident.source_id!,
    id: apiIncident.id,
    ut: apiIncident.ut,
  }
}

export function getAppIncident(
  id: Incident['id'],
  incidents: Incident[],
  incidentIdIncidentIndexMap: IncidentIdIncidentIndexMap,
): Incident | null {
  const incidentIndex = incidentIdIncidentIndexMap.get(id)

  if (incidentIndex !== undefined) {
    return incidents[incidentIndex]
  }

  return null
}

/**
 * Creates an incident update with current incident data snapshot for a specific incident
 */
export function getIncidentUpdate(
  currentIncident: Incident,
  newIncident: RabbitIncidentMessage,
): IncidentUpdate {
  return {
    ...newIncident,
    data: currentIncident,
    currentData: R.clone(currentIncident),
  }
}
